import React, { useEffect, useState } from "react";
import { Tabs, Layout } from "antd";
import EmployeesList from "./components/EmployeesList";
import StaffList from "../staff";
import { FormattedMessage } from "react-intl";
import Surface from "../../components/layouts/Surface";
import { useLocation } from "react-router-dom";

const Employees = (props) => {
  const [activeTab, setActiveTab] = useState("employees_list");
  let location = useLocation();

  useEffect(() => {
    if (location.fromState && location.fromState.staff) {
      onChange("staff_workers");
    }
  }, [location.fromState]);

  const onChange = (key) => {
    setActiveTab(key);
  };

  return (
    <Layout>
      <Tabs
        defaultActiveKey="employees_list"
        onChange={onChange}
        activeKey={activeTab}
        items={[
          {
            label: <FormattedMessage id="app.employees.employees_list" />,
            key: "employees_list",
            children: (
              <Surface>
                <EmployeesList activeTab={activeTab} />
              </Surface>
            ),
          },
          {
            label: <FormattedMessage id="app.employees.staff_workers" />,
            key: "staff_workers",

            children: (
              <Surface>
                <StaffList activeTab={activeTab} />
              </Surface>
            ),
          },
        ]}
      />
    </Layout>
  );
};

export default Employees;
